<template>
  <div>
    <!--导航条-->
    <div class="title-navBox" v-if="navList">
      <div v-for="(item,index) in navList" @click="navClick(item,index)">
        <span :class="actionNav == index ? 'title-navBox-action' : ''">{{item.title}}</span>
        <i></i>
      </div>

    </div>
    <!---->
    <div style="background: #FBFAFF">
      <div class="container pt-3">
        <el-row :gutter="20" class="pt-5 pb-5">
          <el-col :span="8" v-for="(item,index) in list" :key="item.cid">
            <div class="product-imgList" @click="detailClick(item)">
              <img :src="filePathPrefix + item.pic" class="d-block w-100">
              <div>
                <label>{{item.title}}</label>
                <p>{{item.summary}}</p>
              </div>
            </div>
          </el-col>
        </el-row>
        <!--分页-->
        <div class="pb-4" style="text-align: right;" v-if="total > 0">
          <el-pagination background layout="prev, pager, next"
                         :total="total" :page-size="params.limit" @current-change="handleCurrentChange"></el-pagination>
        </div>

      </div>
    </div>
    <!--富文本内容-->
    <div class="product-content">
       <div class="product-contentTitle">
         <label>{{itemJson.title}}</label>
         <div>
           <span>{{itemJson.gtmCreate}}</span>
           <img src="../../assets/img/footer/youjian.png" height="15">
           <img src="../../assets/img/footer/youjian.png" height="15">
           <img src="../../assets/img/footer/youjian.png" height="15">

           <i class="el-icon-share"></i>
           <span>分享</span>
         </div>
       </div>
      <div>
        <div class="mt-3 mb-5" v-html="itemJson.content"></div>
      </div>
    </div>


  </div>
</template>

<script>
  import { getIndexPicDOList, getNewsDOList, getColumnTreeList, getNewsDetail } from "@/api/index";
  export default {
    data() {
      return {
        pid: null,
        actionNav: 0,
        navList: [],
        params: {
          page: 1,
          limit: 3,
          offset: 0,
          type: null,
        },
        list: [],
        total: 0,
        itemJson: {},
        cid: null,
        typeId: null,
      }
    },
    components: {

    },
    //监听参数的变化，如监听路由中id值的变化：
    watch: {
      '$route.query.id': {
        handler(newVal, oldVal) {
          //判断newVal有没有值监听路由变化
          if(newVal != oldVal){
            this.pid = this.$route.query.id;
            this.typeId = this.$route.query.type;
            this.cid = this.$route.query.cid;
            this.navList = [];
            this.list = [];
            getColumnTreeList({id: this.$route.query.id}).then(response => {
              if(response[0].children.length == 0){
                this.params.type = this.$route.query.id;
                this.findList();
              }else{
                this.navList = response[0].children;
                if(this.typeId){
                  this.navList.forEach((item ,index) => {
                    if(item.id == this.typeId ){
                      this.actionNav = index;
                      this.params.type = item.id;
                    }
                  })
                }else{
                  this.params.type = this.navList[0].id;
                }
                this.findList();
              }
            });
          }
        },
        deep: true
      }
    },
    mounted() {
      this.typeId = this.$route.query.type;
      this.pid = this.$route.query.id;
      this.cid = this.$route.query.cid;
      getColumnTreeList({id: this.$route.query.id}).then(response => {
        if(response[0].children.length == 0){
          this.params.type = this.$route.query.id;
          this.findList();
        }else{
          this.navList = response[0].children;
          if(this.typeId){
            this.navList.forEach((item ,index) => {
              if(item.id == this.typeId ){
                this.actionNav = index;
                this.params.type = item.id;
              }
            })
          }else{
            this.params.type = this.navList[0].id;
          }
          this.findList();
        }
      });

    },
    methods: {
      /*导航点击*/
      navClick(item,index){
        this.actionNav = index;
        this.params.type = item.id;
        this.params.page = 1;
        this.params.offset = 0;
        this.findList();
      },
      /*查询新闻列表*/
      findList(){
        this.list = [];
        getNewsDOList(this.params).then(response => {
          this.list = response.rows;
          this.total = response.total;
          if(this.cid){
            getNewsDetail(this.cid).then(response => {
              this.itemJson = response;
            })
          }else {
            if(response.rows.length > 0 && this.params.page == 1){
              this.itemJson = this.list[0];
            }
          }
        });
      },
      /*点击新闻详情*/
      detailClick(item){
        this.itemJson = item;
      },
      /*分页*/
      handleCurrentChange(val) {
        this.params.page = val;
        this.params.offset = (val - 1) * 3;
        this.findList();
      }

    }
  }
</script>

<style scoped lang="less">
  .title-navBox{
    display: flex;
    border-top: 1px solid #D0D0D0;
    border-bottom: 1px solid #D0D0D0;
    &>div{
      display: flex;
      &>span{
        display:block;
        padding: 10px 30px;
      }
      &>span:hover{
        background: #043B86;
        color: #fff;
      }
      &>i{
        display: block;
        height: 25px;
        border-right: 1px solid #D0D0D0;
        margin-top: 10px;
      }
    }
    .title-navBox-action{
      background: #043B86;
      color: #fff;
    }
  }
  .product-imgList{
    &>img{
      height: 260px;
    }
    &>div{
      background: #fff;
      padding: 12px;
      height: 110px;
      &>label{
        font-size: 15px;
        display: block;
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        white-space: nowrap;
      }
      &>p{
        font-size: 13px;
        color: #636263;
        /*text-overflow: -o-ellipsis-lastline;*/
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }
  }
  .product-content{
    padding: 12px;
    &>div{
      padding: 0 50px;
    }
    .product-contentTitle{
      border-bottom: 1px solid #D0D0D0;
      padding-top: 20px;
      padding-bottom: 15px;
      &>label{
        line-height: 30px;
        font-weight: bold;
        font-size: 18px;
        display: block;
      }
      &>div{
        font-size: 13px;
        &>span{
          color: #999;
          padding-right: 10px;
        }
        &>i{
          color: #999;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/product/index.vue